import { createRouter, createWebHistory } from 'vue-router';
import { applyPageMeta } from '@/services/pageMeta';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'Home', component: () => import('@/views/HomeView.vue') },
    { path: '/o-grupo', name: 'OGrupo', component: () => import('@/views/OGrupoView.vue') },
    {
      path: '/nossa-historia',
      name: 'NossaHistoria',
      component: () => import('@/views/NossaHistoriaView.vue'),
    },
    { path: '/proposito', name: 'Proposito', component: () => import('@/views/PropositoView.vue') },
    {
      path: '/empresas-do-grupo',
      name: 'EmpresasDoGrupo',
      component: () => import('@/views/EmpresasDoGrupoView.vue'),
    },
    {
      path: '/governanca',
      name: 'Governanca',
      component: () => import('@/views/GovernancaView.vue'),
    },
    {
      path: '/perguntas-frequentes',
      name: 'PerguntasFrequentes',
      component: () => import('@/views/PerguntasFrequentesView.vue'),
    },
    { path: '/solucoes', name: 'Solucoes', component: () => import('@/views/SolucoesView.vue') },
    { path: '/setores', name: 'Setores', component: () => import('@/views/SetoresView.vue') },
    {
      path: '/empresas-familiares',
      alias: '/setores/empresas-familiares',
      name: 'EmpresasFamiliares',
      component: () => import('@/views/EmpresasFamiliaresView.vue'),
    },
    { path: '/insights', name: 'Insights', component: () => import('@/views/InsightsView.vue') },
    { path: '/contato', name: 'Contato', component: () => import('@/views/ContatoView.vue') },
    {
      path: '/informacoes',
      name: 'Informacoes',
      component: () => import('@/views/InformacoesView.vue'),
    },
    {
      path: '/solucoes/:id(\\d+)/:nome?',
      name: 'DetalheDaSolucao',
      component: () => import('@/views/DetalheDaSolucaoView.vue'),
    },
    {
      path: '/insights/:id(\\d+)/:nome?',
      name: 'DetalhePublicacao',
      component: () => import('@/views/DetalhePublicacaoView.vue'),
    },
    {
      path: '/informacoes/:id(\\d+)/:nome?',
      name: 'DetalheInformacao',
      component: () => import('@/views/DetalheInformacaoView.vue'),
    },
    { path: '/:pathMatch(.*)*', component: () => import('@/views/NotFoundView.vue') },
  ],
  scrollBehavior(to, from, saved) {
    return saved || (to.hash ? false : { top: 0 });
  },
});
router.beforeEach((to) => {
  window.__PAGE_READY__ = false;
  applyPageMeta({ path: to.path });
});
export default router;
